/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_EMPLOYEE_ACTION_COMPLETION = gql`
  query GetEmployeeActionCompletion(
    $filters: ActionsInput!
    $order: SortDirection
  ) {
    employeeActionCompletion(filters: $filters, order: $order) {
      user {
        id
      }
      numberOfCompletions
      rank
    }
  }
`
